import { useNuxtApp } from '#app';
import { tracker } from '../ClickStreamTracker';
import type { IEventProperties } from '../models/eventProperties';
import type { RouteLocationNormalized } from 'vue-router';

export function useTracker(defaultPayload: Partial<IEventProperties> = {}) {
  const nuxtApp = useNuxtApp();
  const getCurrentRoute = () => nuxtApp.$router.currentRoute.value as RouteLocationNormalized;

  return {
    track: (extraPayload: Partial<IEventProperties> = {}) => {
      const route = getCurrentRoute();
      if (!route.name) {
        console.warn('Route is undefined in useTracker');
      }
      tracker.track({ ...defaultPayload, ...extraPayload } as IEventProperties, route);
    },
  };
}
